// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2cym-","savePackageButton":"ClientWallet_savePackageButton__1JxJ8"};